/**
 * Configuração da tela lida NA HORA DE SUBIR, não na construção da imagem (ADR-158 D7).
 *
 * O contêiner escreve `/config.js` ao iniciar (`infra/docker/lume-config.sh`), a partir das
 * variáveis `LUME_ENGINE_URL` e `LUME_TENANT_SLUG` do ambiente. O `index.html` carrega esse
 * arquivo ANTES do app, e ele define `window.__LUME_CONFIG__`. Assim a mesma imagem serve ao
 * hml e à produção — antes, o endereço do engine era assado no build (`VITE_ENGINE_URL`) e a
 * imagem testada no hml não podia ser a que ia para a produção.
 *
 * Precedência: contêiner → build (`VITE_*`, que segue valendo: dev e o pipeline do Rancher 1.6
 * usam) → padrão de desenvolvimento. Domicílio único: antes, quatro arquivos repetiam a leitura.
 */
interface ConfigDoConteiner {
  engineUrl?: unknown;
  tenantSlug?: unknown;
}

const ENGINE_DEV = 'http://localhost:3100';

function doConteiner(): ConfigDoConteiner {
  if (typeof window === 'undefined') return {};
  const c = (window as Window & { __LUME_CONFIG__?: unknown }).__LUME_CONFIG__;
  return c !== null && typeof c === 'object' ? c : {};
}

/**
 * O que o build assou. Acesso LITERAL (`import.meta.env.VITE_…`) de propósito: é a forma que o
 * Vite substitui no build e que o vitest enxerga; acesso dinâmico por chave escapa às duas.
 */
function doBuild(nome: 'VITE_ENGINE_URL' | 'VITE_TENANT_SLUG'): string | undefined {
  const v =
    nome === 'VITE_ENGINE_URL'
      ? (import.meta.env.VITE_ENGINE_URL as string | undefined)
      : (import.meta.env.VITE_TENANT_SLUG as string | undefined);
  return v !== undefined && v.length > 0 ? v : undefined;
}

function texto(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}

/** Endereço do engine (REST e WebSocket). */
export function engineUrl(): string {
  return texto(doConteiner().engineUrl) ?? doBuild('VITE_ENGINE_URL') ?? ENGINE_DEV;
}

/**
 * Tenant fixado pelo ambiente, quando o endereço não o carrega. Ex.: no hml da plataforma nova,
 * `lume.hml.netcomet.com.br` — a borda só encaminha um nível de subdomínio, então o primeiro
 * rótulo («lume») não é o tenant. `undefined` = o tenant sai do endereço.
 */
export function tenantSlugFixo(): string | undefined {
  return texto(doConteiner().tenantSlug) ?? doBuild('VITE_TENANT_SLUG');
}
